module.exports = __webpack_public_path__ + "assets/img/downloadSamples.86a91cc7.svg";